import React from 'react'

import { ExplainContents } from 'components/Explain'
import { useAccountAccountExplain } from 'hooks/useAccountExplain'

import BaseCard from '../BaseCard'
import { CardHeader,CardHeaderExpandProps } from '../CardHeader'
import EmptyCardText from '../EmptyCardText'

import styles from './styles.module.css'

export const ExplainSidebarCardHeader: React.FC<CardHeaderExpandProps> = ({ ...rest }) => {
  return (
    <CardHeader
      data-ocweb-id="ExplainCardHeader"
      content={
        <div className={styles.companyHeaderContent}>
          <div>Engagement score</div>
        </div>
      }
      {...rest}
    />
  )
}

export const ExplainSidebarCard: React.FC = () => {
  const { data, error } = useAccountAccountExplain()

  const hasDataToDisplay =
    !error &&
    data &&
    Object.keys(data.activityTypeExplain).length > 0 &&
    data.normalizedEngagementScore

  return (
    <BaseCard data-ocweb-id="ExplainCard">
      {!hasDataToDisplay ? (
        <EmptyCardText
          data-ocweb-id="EmptyExplainText"
          content="We don't currently have an engagement score for this account"
        />
      ) : (
        <>
          {data && (
            <div className={styles.explainCardStyles}>
              <ExplainContents
                accountActivity={data}
                includeHeader={false}
                displayContextHasBottomBorder={true}
              />
            </div>
          )}
        </>
      )}
    </BaseCard>
  )
}
